import { memo, type ReactNode } from 'react';

import { KanbanNullState } from '~/components/KanbanNullState/KanbanNullState';

type PublicKanbanNullStateProps = {
  action?: ReactNode;
};

export const PublicKanbanNullState = memo(({ action }: PublicKanbanNullStateProps) => (
  <KanbanNullState
    action={action}
    title="No Kanban view yet"
    text="Columns will appear here once this board has a single‑select field."
  />
));

PublicKanbanNullState.displayName = 'PublicKanbanNullState';
